var getters = {
  appConfig: function appConfig(state) {
    return state.app.appConfig;
  },
  token: function token(state) {
    return state.user.token;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  realNameInfo: function realNameInfo(state) {
    return state.user.realNameInfo;
  },
  tradePwd: function tradePwd(state) {
    return state.user.tradePwd;
  },
  hasLogin: function hasLogin(state) {
    return state.user.token;
  },
  themeColor: function themeColor(state) {
    return state.app.themeColor;
  },
  keepAliveArrs: function keepAliveArrs(state) {
    return state.user.keepAliveArrs;
  },
  togetherFly: function togetherFly(state) {
    return state.app.configData.togetherFly;
  },
  // 必由之径专题id
  accumulatePrice: function accumulatePrice(state) {
    return state.app.configData.accumulatePrice;
  },
  // 铸造专题加价幅度
  artKey: function artKey(state) {
    return state.app.configData.artKey;
  },
  // 艺术专题id
  payChannelEnable: function payChannelEnable(state) {
    return state.app.configData.payChannelEnable;
  },
  // 支付宝方式
  jumpUrl: function jumpUrl(state) {
    return state.app.jumpUrl;
  },
  specialTheme: function specialTheme(state) {
    return state.app.configData.specialTheme;
  },
  // 艺术专题id
  fyWalletInfo: function fyWalletInfo(state) {
    return state.user.fyWalletInfo;
  },
  activitiesInfo: function activitiesInfo(state) {
    return state.app.activitiesInfo;
  },
  // 活动数据
  modeAStores: function modeAStores(state) {
    var FEE_MODE_A_STORES = state.app.configData.FEE_MODE_A_STORES;
    var result = [];
    if (FEE_MODE_A_STORES) {
      result = FEE_MODE_A_STORES.split(',');
    }
    return result;
  },
  // 收费模式A的品牌馆
  taxChangeSwitch: function taxChangeSwitch(state) {
    return state.app.configData.tax_change_switch;
  },
  // 是否自助纳税开关
  minWithDrawUbq: function minWithDrawUbq(state) {
    return state.app.configData.minWithDrawUbq;
  },
  // 最小提现额度
  skinChange: function skinChange(state) {
    return state.app.skinChange;
  },
  // 新年换肤
  getForwardPage: function getForwardPage(state) {
    return state.app.isForwardPage;
  },
  // 如果是app通过forward页面打开的不隐藏头
  partyPlanetSwitch: function partyPlanetSwitch(state) {
    return state.app.configData.partyPlanetSwitch;
  },
  // 派对星球发现页入口展示开关
  getPushHistoryLength: function getPushHistoryLength(state) {
    return state.app.pushHistoryLength;
  },
  // 记录特定场景的 push History 长度 便于特定场景的路由返回 go(-n)
  assetHidden: function assetHidden(state) {
    return state.app.assetHidden;
  },
  // 记录是否隐藏资产估值
  getOrderTips: function getOrderTips(state) {
    // 获取订单默认提示语
    var _state$app$configData = state.app.configData,
      _state$app$configData2 = _state$app$configData.cancelOrderMsg,
      cancelOrderMsg = _state$app$configData2 === void 0 ? '' : _state$app$configData2,
      _state$app$configData3 = _state$app$configData.makeOrderMsg,
      makeOrderMsg = _state$app$configData3 === void 0 ? '' : _state$app$configData3,
      _state$app$configData4 = _state$app$configData.orderRules,
      orderRules = _state$app$configData4 === void 0 ? '' : _state$app$configData4;
    return {
      cancelOrderMsg: cancelOrderMsg,
      makeOrderMsg: makeOrderMsg,
      orderRules: orderRules
    };
  },
  userWalletList: function userWalletList(state) {
    return state.user.userWalletList;
  },
  // 用户钱包列表
  payChannelList: function payChannelList(state) {
    return state.user.payChannelList;
  },
  // 支付通道列表
  defaultPayChannel: function defaultPayChannel(state) {
    return state.user.defaultPayChannel;
  } // 默认支付方式
};
export default getters;